import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../common/html/checkbox/index'
import {
  changeCheckedIds,
  selectAlertIds,
  selectCheckedIds,
} from '../store/slice'

export const CheckboxAll = () => {
  const dispatch = useDispatch()

  const alertIds = useSelector(selectAlertIds)
  const checkedIds = useSelector(selectCheckedIds())

  const getChecked = () => {
    const isAllChecked =
      alertIds.length && alertIds.every((id) => checkedIds[id])
    const isSomeChecked = alertIds.some((id) => checkedIds[id])
    return isAllChecked ? true : isSomeChecked ? -1 : false
  }

  const onChange = (isCheck) => {
    const payload = alertIds.reduce(
      (prev, curr) => ({ ...prev, [curr]: isCheck }),
      {},
    )
    dispatch(changeCheckedIds(payload))
  }

  return <Checkbox checked={getChecked()} onChange={onChange} />
}
